import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
//import "@clayui/css/lib/css/atlas.css";
import './index.css';

class WebComponent extends HTMLElement {
    root: any;

	connectedCallback() {
		this.root = createRoot(this);

		this.root.render(<App />);

	}

	disconnectedCallback() {
		this.root.unmount();
		delete this.root;
	}
}

const ELEMENT_ID = 'kdr-form-fe';

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}
